import React, { FC } from "react";
import { Field } from "formik";

import BaseInput from "../../../../../../components/elements/BaseInput";
import FormFieldError from "../../../../../../components/elements/FormFieldError";
import classes from "../AdGroupCreationForm.module.scss";

type NameAndDescriptionFillStepProps = {
  values: {
    name: string;
    description: string;
  };
};

const NameAndDescriptionFillStep: FC<NameAndDescriptionFillStepProps> = ({ values }) => {
  return (
    <div>
      <div className={classes.input}>
        <Field
          as={BaseInput}
          value={values.name}
          name="name"
          variant="outlined"
          label="Set the name of the ad group *"
        />

        <FormFieldError name="name" />
      </div>

      <div className={classes.textArea}>
        <Field
          as={BaseInput}
          value={values.description}
          name="description"
          variant="outlined"
          label="Description"
          rows={3}
          multiline
        />

        <FormFieldError name="description" />
      </div>
    </div>
  );
};

export default NameAndDescriptionFillStep;
